/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { IAudienceMultiplier } from "."
 * @import { ContentInfo } from "../content/info/content-info"
 */

const defaultAudienceMultiplier = 1;

/**
 * @implements {IAudienceMultiplier}
 */
export default class ContentSettingsAudienceMultiplier {
  /**
   * @param {ContentInfo} contentInfo
   */
  constructor(contentInfo) {
    /** @type {number} */
    this.multiplier = this.parseAudienceMultiplier(contentInfo);
  }

  /** @type {IAudienceMultiplier['get']} */
  async get() {
    return await this.multiplier;
  }

  /**
   * Vrátí výchozí hodnotu pro neplatné nebo <= 0 hodnoty. Jinak vrací naparsovanou hodnotu z contentInfo.
   * @private
   * @param {Pick<ContentInfo, 'communicatorSettings'>} contentInfo
   * @returns {number}
   */
  parseAudienceMultiplier(contentInfo) {
    const audienceMultiplierString = contentInfo.communicatorSettings.get(
      'player.audience.input.count'
    );
    if (!audienceMultiplierString) {
      return defaultAudienceMultiplier;
    }
    const num = parseInt(audienceMultiplierString, 10);
    return num > 0 ? num : defaultAudienceMultiplier;
  }
}
